
(function(template){
    define('vue!app/views/vue/components/cartComponent/cartBody/scheduleButtonComponent',['Vue','vuex','underscore', 'helpers'],function(Vue,vuex,_, helpers){
        return {
            template:template,
            data: function(){
                return {
                    location: null,
                    username:""
                }
            },
            props:['is_service_booked'],
            methods: _.extend(vuex.mapMutations(['setActiveStep','addUserWithId']),{
                bookmore:function(){
                    if(!this.desktopMode) this.$store.commit('setmobileCategoryShow',true)
                    this.$store.commit('setReviewScreenBookingDetails',{})//empty booking details for review screen before it set again
                    this.$store.commit('setActiveStep', 0)
                },
                bookService: function(){
                    if(this.OTBactive && (this.$store.state.status != 'E') || this.activeStep == 1)this.$store.commit('SetbookFromCart',true)
                    if(this.activeStep == 2){
                        this.$store.commit('setActiveStep', 0);
                        app.dispatcher.currentRoute = {0: 'summary', 1: 'show', 2: ''};
                        app.dispatcher.redirect('summary');
                    }
                },

                canEditingService:function () {
                    this.$store.commit('setmobileCategoryShow',true) // to bring it to category page
                    this.$store.commit('setActiveStep',0)
                },

                gotToBookingSummary: function(){
                    this.$store.commit('setActiveStep', 0);
                    app.dispatcher.currentRoute = {0: 'summary', 1: 'show', 2: ''};
                    app.dispatcher.redirect('summary');
                }
            }),
            computed: _.extend(
                vuex.mapState(['users','activeStep','desktopMode','bookingButtonText','detectedChanges','currentlyEditingService','OTBactive', 'dynamicRestErrorMessage']),
                {
                    locationName:function(){
                        var locationData = helpers.getSelectedLocation();
                        return locationData.LocationName;
                    },
                    conditionsToBookorEdit: function () {
                          var canBook = false
                          var vm = this
                          var staffRestrictionResult = StaffRequirmentLogic(vm)
                          if (vm.is_service_booked) {
                              if (vm.detectedChanges.note || vm.detectedChanges.staff || vm.detectedChanges.time && staffRestrictionResult) canBook = true
                          } else {
                              if (vm.detectedChanges.time && staffRestrictionResult) canBook = true
                          }
                          function StaffRequirmentLogic(vm) {
                              var noRestriction = true
                              if (vm.staffPickRequired && vm.detectedChanges.staff) noRestriction = false
                              return noRestriction
                          }
                          return canBook
                      },
                      reserveBtnText: function(){
                        if(this.is_service_booked && this.activeStep ==1) {return "Update"}
                        else if(this.OTBactive && (this.$store.state.status != 'E')){
                            return this.localStrings.stepper.body.schedule.bookingButtonText.buttonText[1]
                        }
                        else  return this.localStrings.stepper.body.schedule.bookingButtonText.buttonText[this.activeStep]
                      }

                }
            ),
        }
    })
})('<div > <div> <button v-if="dynamicRestErrorMessage && is_service_booked" class="btn btn-primary package-review-screen-bookmore-btn dynamic-rest-but" @click="bookmore"> <span class="package-review-screen-bookmore-btn-span-1">{{localStrings.stepper.body.review.bookAnotherService}} {{locationName}}</span> <span class="package-review-screen-bookmore-btn-span-2"><i v-if="!desktopMode" class="fas fa-chevron-circle-right"></i></span> </button> <button v-if="!OTBactive && (conditionsToBookorEdit && desktopMode || !desktopMode || !is_service_booked)" :class="{\'disabled-reserve-button-color\': !conditionsToBookorEdit, \'disabled\': dynamicRestErrorMessage && activeStep != 1}" class="btn btn-primary user-info-reserve-button" v-on:click="bookService"> {{reserveBtnText}} </button> <button v-if="OTBactive && (this.$store.state.status == \'E\') && (conditionsToBookorEdit && desktopMode || !desktopMode || !is_service_booked)" :class="{\'disabled-reserve-button-color\': !conditionsToBookorEdit, \'disabled\': dynamicRestErrorMessage && activeStep != 1}" v-on:click="bookService" class="btn btn-primary user-info-reserve-button">{{reserveBtnText}}</button> <button v-show="is_service_booked && !conditionsToBookorEdit" v-on:click="canEditingService" class="btn btn-primary user-info-cancel-button">{{this.localStrings.stepper.body.schedule.bookingButtonText.cancelText}} </button> </div> <button v-show="is_service_booked && OTBactive && (this.$store.state.status != \'E\')" v-on:click="gotToBookingSummary" class="btn btn-primary user-info-reserve-button">{{localStrings.stepper.body.schedule.bookingButtonText.compRes}}</button> </div>');
